import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function General({generalBar, toggleGeneralBar }) {
    const { user } = useUser();
    const [minWithdraw, setMinWithdraw] = useState();
    const [fee, setFee] = useState();
    const [upgradeMessage, setUpgradeMessage] = useState();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    useEffect(() => {
      if(minWithdraw && upgradeMessage){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [minWithdraw, upgradeMessage]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchadmin: true })
        })
        .then(response =>  response.json())
        .then(data => {
          if (data.status === "success") {
            setMinWithdraw(data.admin.minSiteAmount);
            setUpgradeMessage(data.admin.upgrade_text);
            setFee(data.admin.retirement_fee);
          }else{
            toast.error(data.message);
          }
        })
        .catch(err => {
        })
    }, [user]);

    const ValidateSave = () =>{
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ adminupdate: true, min: minWithdraw, upgrade: upgradeMessage, fee: fee })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toggleGeneralBar();
          toast.success(data.result);
        }else{
          toast.error(data.message);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err)
        setLoading(false);
      })
    }
    return (
    <div className={`notifybar ${generalBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleGeneralBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">App Settings</p>
            </div> 
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleGeneralBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto'}}>
            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>Minimum Withdraw (USD):</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                  type="text"
                  placeholder="Minimum Withdraw"
                  className="inputNone"
                  value={minWithdraw}
                  onChange={(e) => setMinWithdraw(e.target.value)}
                />
            </div>
            <label className="fw-semibold my-2" style={{fontSize: '14px'}}>401(k) Withdraw Fee:</label>
            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                <input 
                  type="text"
                  placeholder="Minimum Withdraw"
                  className="inputNone"
                  value={fee}
                  onChange={(e) => setFee(e.target.value)}
                />
                <span>%</span>
            </div>
            <label className="fw-semibold my-2" style={{fontSize: '14px'}}>Upgrade Text:</label>
            <textarea 
                placeholder="Upgrade Message p-2"
                className="form-control"
                value={upgradeMessage}
                onChange={(e) => setUpgradeMessage(e.target.value)}
                rows={6}
            />
            <div className={`myBtn w-100 text-center mt-5 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateSave : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
        </div>
    </div>
    )
}

export default General